// Utility to prevent redirect loops
let lastRedirectTime = 0;
let redirectCount = 0;
const MAX_REDIRECTS = 3;
const REDIRECT_WINDOW = 2000; // 2 seconds

export const shouldAllowRedirect = (path: string): boolean => {
  const now = Date.now();

  // Reset counter if outside the time window
  if (now - lastRedirectTime > REDIRECT_WINDOW) {
    redirectCount = 0;
  }

  // Check if this is a login <-> dashboard loop
  const isLoopingPath = path === "/login" || path === "/dashboard";
  const wasRecentRedirect = now - lastRedirectTime < 500; // Very recent redirect

  if (isLoopingPath && wasRecentRedirect) {
    redirectCount++;
    if (redirectCount >= MAX_REDIRECTS) {
      console.warn("Redirect loop detected, preventing redirect to:", path);
      return false;
    }
  }

  lastRedirectTime = now;
  return true;
};

export const resetRedirectCounter = (): void => {
  redirectCount = 0;
  lastRedirectTime = 0;
};
